"use strict";
/**************************
 * ************************
 * ************************
 *
 * COPIED FROM https://github.com/Bond-Sports/NotificationsService
 *
 * + Convenience API added.
 *
 * ************************
 * ************************
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationCreateDto = exports.ContentDto = exports.RecipientsDto = exports.SenderDto = void 0;
const notifications_sdk_1 = require("@bondsports/notifications-sdk");
// This file contains DTOs for sending notifications with the SendService.
// Start at the Notification object, below.
// It contains all the other request objects.
class SenderDto {
    // Added for convenience.
    // Not part of NotificationsService object definitions.
    constructor(userId, organizationId, facilityId, replyTo, fromDisplayName) {
        this.userId = userId;
        this.organizationId = organizationId;
        this.facilityId = facilityId;
        this.replyTo = replyTo;
        this.fromDisplayName = fromDisplayName;
    }
}
exports.SenderDto = SenderDto;
// used in cases where the user is unknown / unknowable (ie. "system" generated without clear user action)
SenderDto.UNKNOWN_USER_ID = -10;
class RecipientsDto {
    // Added for convenience.
    // Not part of NotificationsService object definitions.
    static to(to) {
        const r = new RecipientsDto();
        r.to = to ? [to] : [];
        return r;
    }
    constructor(to, cc, bcc) {
        this.to = to || [];
        this.cc = cc;
        this.bcc = bcc;
    }
}
exports.RecipientsDto = RecipientsDto;
class ContentDto {
    // Added for convenience.
    // Not part of NotificationsService object definitions.
    constructor(subject, bodyHtml, bodyText) {
        this.bodyText = bodyText;
        this.bodyHtml = bodyHtml;
        this.subject = subject;
    }
}
exports.ContentDto = ContentDto;
class NotificationCreateDto {
    constructor() {
        this.classification = notifications_sdk_1.NotificationClassification.UNKNOWN;
    }
    /**
     * Use NotificationCreateDto.emailTemplate(...) instead.
     */
    static sendgridTemplate(toEmailAddress, dynamicTemplateData, sendingUserId, sendingOrganizationId, sendingFacilityId) {
        const note = new NotificationCreateDto();
        note.channel = notifications_sdk_1.NotificationDeliveryChannel.EMAIL;
        note.classification = notifications_sdk_1.NotificationClassification.TRANSACTIONAL;
        note.sender = new SenderDto(sendingUserId, sendingOrganizationId, sendingFacilityId);
        note.recipients = [RecipientsDto.to(toEmailAddress)];
        // there is no Content object when using a sendgrid template, it's the template and dynamic data:
        note.deliveryPayload = {
            // `templateId` *is necessary* -- it is looked up (via template Name) & set in the NotificationsService.
            dynamicTemplateData: dynamicTemplateData,
        };
        return note;
    }
    /**
     * Send an email notification using a templateKey and dynamic data.
     *
     * (Added for convenience; Not part of NotificationsService object definitions.)
     *
     */
    static emailTemplate(toEmailAddress, templateKey, dynamicTemplateData, sendingUserId, sendingOrganizationId, sendingFacilityId) {
        const note = new NotificationCreateDto();
        note.channel = notifications_sdk_1.NotificationDeliveryChannel.EMAIL;
        note.classification = notifications_sdk_1.NotificationClassification.TRANSACTIONAL;
        note.sender = new SenderDto(sendingUserId, sendingOrganizationId, sendingFacilityId);
        note.recipients = [RecipientsDto.to(toEmailAddress)];
        // there is no Content object when using an email template, it's the templateKey and dynamic data to be interpolated:
        note.deliveryPayload = {
            // templateId is not used.  It's a legacy field from when we used SendGrid templates.
            templateKey: templateKey,
            dynamicTemplateData: dynamicTemplateData, // used by NotificationService when rendering the template.
        };
        return note;
    }
}
exports.NotificationCreateDto = NotificationCreateDto;
//# sourceMappingURL=notification.create.dto.js.map